import axios from "axios";
//const BASE_URL = "http://localhost:8080";
//const BASE_URL = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
const BASE_URL = "";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
